<template>
  <div class="flex items-center">
    <feather-icon :icon="icon" :color="resolveColor" :svgClasses="['h-4 w-4', resolveColor]" />
    <span :class="['ml-1', resolveColor]"> {{ params.value }}</span>
    <!-- <vs-avatar :src="params.data.avatar" class="flex-shrink-0 mr-2" size="30px" @click="$router.push(url)" />
    <router-link :to="url" @click.stop.prevent class="text-inherit hover:text-primary">{{ params.value }}</router-link> -->
  </div>
</template>

<script>
    export default {
        name: 'CellRendererLink',
        computed: {
          icon() {
            switch (this.params.data.payment_status_id) {
              case 0: return "CheckCircleIcon"
              case 1: return "AlertTriangleIcon"
              case 2: return "ClockIcon"
              default: return ""
            }
          },
          resolveColor() {
            switch (this.params.data.payment_status_id) {
              case 0: return "text-success"
              case 1: return "text-danger"
              case 2: return "text-primary"
              default: return ""
            }
          }
        },

    }
</script>
